import { render, staticRenderFns } from "./ListResponsavelGrupoEconomicoView.vue?vue&type=template&id=485b54e0&"
import script from "./ListResponsavelGrupoEconomicoView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelGrupoEconomicoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports